import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import { AppContext, AccountFeatures } from '@lightspeed-invoicing/core-client/frontend'
import SideBar from "../../common/layout/sidebar.component.jsx"
import ProposalContent from "../../proposal/content.component.jsx"
import { Link } from "react-router-dom";
import Icon from "../../common/icon/icon.component.jsx";
import ProposalPreviewModal from "../../common/proposal/previewmodal.component.jsx";
import GlobalHelper from '../../common/GlobalHelper.jsx'
import {STOCK_DOCUMENT} from "../../utils/inventory"

class TemplatePreview extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            proposal: null,
            sections: [],
            hash: this.props.match.params.hash || '',
            documentId: this.props.match.params.documentId || '',
            documentType: '',
            templateLoading: false,
            showToolbar: false,
            redirect: '',
            modal: '',
            mobile: false,
            templateEmail: this.props.templateEmail
        }
        this.refreshProposal = this.refreshProposal.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.toggleToolbar = this.toggleToolbar.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        this.refreshProposal()
    }

    refreshProposal() {
        AppContext.getApiClient().get('/documents/' + this.state.documentId + '/dummy-proposals').then(res => {
            if (GlobalHelper.hasShopifyIntegrationWithDisabledFeatures()) {
                res.attributes.variables.paymentSectionDisabled = true
            }

            this.setState({
                proposal: res.attributes.variables,
                documentId: res.attributes.documentId,
                documentType: res.attributes.documentType,
                sections: res.attributes.variables.sections,
            }, () => { })
        })
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: <ProposalPreviewModal
                onClose={this.handleCloseModal}
                documentId={this.state.documentId}
                onTabChange={(mobile) => {
                    this.setState({
                        mobile,
                    })
                }}
            />
        })
    }

    toggleToolbar(event) {
        event.preventDefault()
        this.setState({
            showToolbar: !this.state.showToolbar
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    render() {

        if (!this.state.proposal) {
            return <LoadingSpinner marginTop="20px" />
        }

        const backUrl = this.state.documentType === STOCK_DOCUMENT ? `/inventory/document-types?templateId=${this.state.documentId}`
            :`/templates/${this.state.documentType}/listing`
        var showBranding = this.state.proposal.global.hasBranding
        return <div>
            {this.state.redirect}
            {this.state.modal}

            <div className={"row justify-content-center mb-5"}>
                <div className={"col-lg-9 col-md-12 pl-5"}>
                    <ProposalContent
                        variables={this.state.proposal}
                        editable={true}
                        showBranding={showBranding}
                        onEdit={this.refreshProposal}
                        isDummy={true}
                        mobile={this.state.mobile}
                        isInsidePreview={true} />
                </div>
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-6">
                                <Link to={backUrl} className="btn btn-light">
                                    <Icon value={"chevron-left"} />
                                    <FormattedMessage
                                        id="templates.section.list.back_btn"
                                        defaultMessage="Back to listing"
                                    />
                                </Link>
                            </div>
                            <div className="col-6 text-align-right ">
                                <button className={"btn btn-primary"} onClick={this.openPreview}>
                                    <Icon value={"eye"} className={"mr-1"} />
                                    <FormattedMessage
                                        id="templates.section.list.preview_btn"
                                        defaultMessage="Preview"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default TemplatePreview





// WEBPACK FOOTER //
// ./src/template/sections/preview.component.jsx